import { ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PrivateRoute from './components/PrivateRouter/PrivateRouter.tsx';
import { CustomApolloProvider } from './graphql/client.tsx';
import './index.css';
import reportWebVitals from './reportWebVitals.js';
import { ROUTER } from './router.tsx';
import { THEME } from './theme.ts';

const root = ReactDOM.createRoot(document.getElementById('root'));

function ScrollToTop() {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
}

export const GENERAL_GROUP_NAME = 'general';

root.render(
	<ThemeProvider theme={THEME}>
		<CustomApolloProvider>
			<BrowserRouter>
				<ScrollToTop />
				<ToastContainer />
				{/* If we ever need cookies: */}
				{/* <CookieConsent location="bottom" buttonText="Akceptuję" cookieName="myAppCookieConsent" style={{ background: '#040F01' }} buttonStyle={{ color: '#040F01', fontSize: '13px', borderRadius: '5px', backgroundColor: '#C48208' }} expires={150}>
                            Licytapka używa ciasteczek, żeby strona działała sprawnie, była łatwiejsza w obsłudze i lepiej dopasowana do Ciebie. Korzystając z naszej strony, akceptujesz ich użycie.
                        </CookieConsent> */}
				<Routes>
					{ROUTER.map((route) => (
						<Route
							key={route.path}
							path={route.path}
							element={route.isPrivate ? <PrivateRoute>{route.element}</PrivateRoute> : route.element}
						/>
					))}
				</Routes>
			</BrowserRouter>
		</CustomApolloProvider>
	</ThemeProvider>
);

reportWebVitals();
